export default __webpack_public_path__ + "assets/images/coins.72ca85.webp";